//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MPA.js";
import "../no/Builder.js";
import "../MPA/MPA.PreferencesArrowConnectionBuilder.js";
import "../MPA/MPA.PreferencesBlocksBuilder.js";
import "../MPA/MPA.PreferencesConnectionsBuilder.js";
import "../MPA/MPA.PreferencesInterfaceBoundaryNodeBuilder.js";
import "../MPA/MPA.PreferencesPhysicalConnectionBuilder.js";
import "../MPA/MPA.PreferencesRoutingConnectionBuilder.js";
import "../MPA/MPA.PreferencesWeldJoinConnectionBuilder.js";
let d=[[[1,"ArrowConnectionBuilder",0,"MPA.PreferencesArrowConnectionBuilder",0],[1,"BlocksBuilder",0,"MPA.PreferencesBlocksBuilder",0],[1,"ConnectionsBuilder",0,"MPA.PreferencesConnectionsBuilder",1],[1,"InterfaceBoundaryNodeBuilder",0,"MPA.PreferencesInterfaceBoundaryNodeBuilder",0],[1,"PhysicalConnectionBuilder",0,"MPA.PreferencesPhysicalConnectionBuilder",0],[1,"RoutingConnectionBuilder",0,"MPA.PreferencesRoutingConnectionBuilder",0],[1,"WeldJoinConnectionBuilder",0,"MPA.PreferencesWeldJoinConnectionBuilder",0]],[],[]];
SPLM.MPA.PreferencesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MPA.PreferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;